import Vue from 'vue';
import Router from 'vue-router';
import Page from '@/pages/page';
import Home from '@/pages/home';
import Login from '@/pages/login';
import Auth from '@/libraries/auth.js';
import { SnackbarProgrammatic as Snackbar } from 'buefy';

//Component
import Config_index from '@/pages/Config/index';

import Product_index from '@/pages/Product/index';
import Product_add from '@/pages/Product/add';

import Supplier_index from '@/pages/Supplier/index';
import Supplier_add from '@/pages/Supplier/add';
import Supplier_view from '@/pages/Supplier/view';

import PurchaseOrder_index from '@/pages/PurchaseOrder/index';
import PurchaseOrder_add from '@/pages/PurchaseOrder/add';
import PurchaseOrder_view from '@/pages/PurchaseOrder/view';
import PurchaseOrder_receive from '@/pages/PurchaseOrder/receive';

import Inventory_index from '@/pages/Inventory/index';
import Inventory_adjustment from '@/pages/Inventory/adjustment';

import Order_index from '@/pages/Order/index';
import Order_add from '@/pages/Order/add';
import Order_view from '@/pages/Order/view';

import Quotation_index from '@/pages/Quotation/index';
import Quotation_add from '@/pages/Quotation/add';
import Quotation_view from '@/pages/Quotation/view';

import Customer_index from '@/pages/Customer/index';
import Customer_add from '@/pages/Customer/add';
import Customer_view from '@/pages/Customer/view';

import User_index from '@/pages/User/index';
import User_add from '@/pages/User/add';

import Group_index from '@/pages/Group/index';
import Group_add from '@/pages/Group/add';

import Report_order from '@/pages/Report/order';
import Report_order_supplier from '@/pages/Report/order_supplier';
import Report_order_sales from '@/pages/Report/order_sales';
import Report_purchase from '@/pages/Report/purchase';
import Report_tax_invoice from '@/pages/Report/tax_invoice';
import Report_account_receivable from '@/pages/Report/account_receivable';
import Report_inventory from '@/pages/Report/inventory';

//Hidden Settings
import Permission_index from '@/pages/Permission/index';
import Permission_add from '@/pages/Permission/add';
import Permission_edit from '@/pages/Permission/add';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Page,

      children: [
        {
          path: '/',
          name: 'Home Dashboard',
          component: Home,
        },

        {
          path: '/config',
          name: 'config',
          component: Config_index,
        },

        //User
        {
          path: '/user',
          name: 'User_index',
          component: User_index,
          meta: {
            crumbs: '/จัดการผู้ใช้งาน',
          },
        },
        {
          path: '/user/add',
          name: 'User_add',
          component: User_add,
          meta: {
            crumbs: '/จัดการผู้ใช้งาน /เพิ่มผู้ใช้งาน',
          },
        },
        {
          path: '/user/edit/:id',
          name: 'User_edit',
          component: User_add,
          meta: {
            crumbs: '/จัดการผู้ใช้งาน /แก้ไขผู้ใช้งาน/*',
          },
        },

        //Group
        {
          path: '/group',
          name: 'Group_index',
          component: Group_index,
          meta: {
            crumbs: '/จัดการกลุ่มผู้ใช้งาน',
          },
        },
        {
          path: '/group/add',
          name: 'Group_add',
          component: Group_add,
          meta: {
            crumbs: '/จัดการกลุ่มผู้ใช้งาน /เพิ่มกลุ่มผู้ใช้งาน',
          },
        },
        {
          path: '/group/edit/:id',
          name: 'Group_edit',
          component: Group_add,
          meta: {
            crumbs: '/จัดการกลุ่มผู้ใช้งาน /แก้ไขกลุ่มผู้ใช้งาน/*',
          },
        },

        {
          path: '/product',
          name: 'Product_index',
          component: Product_index,
          meta: {
            crumbs: '/รายการผลิตภัณฑ์',
          },
        },
        {
          path: '/product/add',
          name: 'Product_add',
          component: Product_add,
          meta: {
            crumbs: '/รายการผลิตภัณฑ์ /เพิ่มผลิตภัณฑ์',
          },
        },
        {
          path: '/product/add/:supId',
          name: 'Product_add_sup',
          component: Product_add,
          meta: {
            crumbs: '/รายการผลิตภัณฑ์ /เพิ่มผลิตภัณฑ์/*',
          },
        },
        {
          path: '/product/edit/:proId',
          name: 'Product_edit',
          component: Product_add,
          meta: {
            crumbs: '/รายการผลิตภัณฑ์ /แก้ไขผลิตภัณฑ์/*',
          },
        },

        {
          path: '/supplier',
          name: 'Supplier_index',
          component: Supplier_index,
          meta: {
            crumbs: '/รายการซัพพลายเออร์',
          },
        },
        {
          path: '/supplier/add',
          name: 'Supplier_add',
          component: Supplier_add,
          meta: {
            crumbs: '/รายการซัพพลายเออร์ /เพิ่มซัพพลายเออร์',
          },
        },
        {
          path: '/supplier/view/:id',
          name: 'Supplier_view',
          component: Supplier_view,
          meta: {
            crumbs: '/รายการซัพพลายเออร์ /รายละเอียดซัพพลายเออร์/*',
          },
        },
        {
          path: '/supplier/edit/:id',
          name: 'Supplier_edit',
          component: Supplier_add,
          meta: {
            crumbs: '/รายการซัพพลายเออร์ /แก้ไขซัพพลายเออร์/*',
          },
        },

        //Purchase Order
        {
          path: '/purchaseorder',
          name: 'PurchaseOrder_index',
          component: PurchaseOrder_index,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์',
          },
        },
        {
          path: '/purchaseorder/view/:id',
          name: 'PurchaseOrder_view',
          component: PurchaseOrder_view,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์ /รายละเอียดการสั่งซื้อผลิตภัณฑ์ /*',
          },
        },
        {
          path: '/purchaseorder/add',
          name: 'PurchaseOrder_add',
          component: PurchaseOrder_add,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์ /เพิ่มรายการสั่งซื้อผลิตภัณฑ์',
          },
        },
        {
          path: '/purchaseorder/add/:supId',
          name: 'PurchaseOrder_add_sup',
          component: PurchaseOrder_add,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์ /เพิ่มรายการสั่งซื้อผลิตภัณฑ์ /*',
          },
        },
        {
          path: '/purchaseorder/edit/:id',
          name: 'PurchaseOrder_edit',
          component: PurchaseOrder_add,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์ /แก้ไขรายการสั่งซื้อผลิตภัณฑ์ /*',
          },
        },
        {
          path: '/purchaseorder/receive/:id',
          name: 'PurchaseOrder_receive',
          component: PurchaseOrder_receive,
          meta: {
            crumbs: '/รายการสั่งซื้อผลิตภัณฑ์ /รับผลิตภัณฑ์ /*',
          },
        },

        //Inventory
        {
          path: '/inventory',
          name: 'Inventory_index',
          component: Inventory_index,
          meta: {
            crumbs: '/สินค้าคงคลัง',
          },
        },
        {
          path: '/inventory/adjustment',
          name: 'Inventory_adjustment',
          component: Inventory_adjustment,
          meta: {
            crumbs: '/สินค้าคงคลัง /ปรับยอดสินค้า',
          },
        },

        //Quotations
        {
          path: '/quotation',
          name: 'Quotation_index',
          component: Quotation_index,
          meta: {
            crumbs: '/ใบเสนอราคา',
            permissions: ['add_quotation', 'edit_quotation', 'delete_quotation', 'issue_quotation'],
          },
        },
        {
          path: '/quotation/view/:id',
          name: 'Quotation_view',
          component: Quotation_view,
          meta: {
            crumbs: '/ใบเสนอราคา /รายละเอียดใบเสนอราคา /*',
          },
        },
        {
          path: '/quotation/add',
          name: 'Quotation_add',
          component: Quotation_add,
          meta: {
            crumbs: '/เพิ่มใบเสนอราคา /เพิ่มใบเสนอราคา',
          },
        },
        {
          path: '/quotation/edit/:id',
          name: 'Quotation_edit',
          component: Quotation_add,
          meta: {
            crumbs: '/เพิ่มใบเสนอราคา /แก้ไขใบเสนอราคา /*',
          },
        },

        //Order
        {
          path: '/order',
          name: 'Order_index',
          component: Order_index,
          meta: {
            crumbs: '/คำสั่งซื้อ',
            permissions: ['add_order', 'edit_order', 'delete_order', 'issue_receipt', 'issue_tax_invoice'],
          },
        },
        {
          path: '/order/view/:id',
          name: 'Order_view',
          component: Order_view,
          meta: {
            crumbs: '/คำสั่งซื้อ /รายละเอียดคำสั่งซื้อ /*',
          },
        },
        {
          path: '/order/add',
          name: 'Order_add',
          component: Order_add,
          meta: {
            crumbs: '/เพิ่มคำสั่งซื้อ /เพิ่มคำสั่งซื้อ',
          },
        },
        {
          path: '/order/edit/:id',
          name: 'Order_edit',
          component: Order_add,
          meta: {
            crumbs: '/เพิ่มคำสั่งซื้อ /แก้ไขคำสั่งซื้อ /*',
          },
        },

        //Customer
        {
          path: '/customer',
          name: 'Customer_index',
          component: Customer_index,
          meta: {
            crumbs: '/จัดการลูกค้า',
          },
        },
        {
          path: '/customer/view/:id',
          name: 'Customer_view',
          component: Customer_view,
          meta: {
            crumbs: '/จัดการลูกค้า /รายละเอียดลูกค้า /*',
          },
        },
        {
          path: '/customer/add',
          name: 'Customer_add',
          component: Customer_add,
          meta: {
            crumbs: '/จัดการลูกค้า /เพิ่มลูกค้า',
          },
        },
        {
          path: '/customer/edit/:id',
          name: 'Customer_edit',
          component: Customer_add,
          meta: {
            crumbs: '/จัดการลูกค้า /แก้ไขลูกค้า /*',
          },
        },

        //Hidden Settings for Admin
        {
          path: '/permission',
          name: 'Permission_index',
          component: Permission_index,
          meta: {
            crumbs: '/จัดการสิทธ์การเข้าถึง',
          },
        },
        {
          path: '/permission/add/:id',
          name: 'Permission_add',
          component: Permission_add,
          meta: {
            crumbs: '/จัดการสิทธ์การเข้าถึง /เพิ่มสิทธ์การเข้าถึง',
          },
        },
        {
          path: '/permission/edit/:id',
          name: 'Permission_edit',
          component: Permission_edit,
          meta: {
            crumbs: '/จัดการสิทธ์การเข้าถึง /แก้ไขสิทธ์การเข้าถึง',
          },
        },

        //Report
        {
          path: '/report/order',
          name: 'Report_order',
          component: Report_order,
          meta: {
            crumbs: '/รายงาน /รายงานยอดขาย',
          },
        },
        {
          path: '/report/order_supplier',
          name: 'Report_order_supplier',
          component: Report_order_supplier,
          meta: {
            crumbs: '/รายงาน /รายงานยอดขาย (Supplier)',
          },
        },
        {
          path: '/report/order_sales',
          name: 'Report_order_sales',
          component: Report_order_sales,
          meta: {
            crumbs: '/รายงาน /รายงานยอดขาย (Sales)',
          },
        },
        {
          path: '/report/purchase',
          name: 'Report_purchase',
          component: Report_purchase,
          meta: {
            crumbs: '/รายงาน /รายงานยอดสั่งซื้อ',
          },
        },
        {
          path: '/report/tax_invoice',
          name: 'Report_tax_invoice',
          component: Report_tax_invoice,
          meta: {
            crumbs: '/รายงาน /รายงาน Tax Invoice',
          },
        },
        {
          path: '/report/account_receivable',
          name: 'Report_account_receivable',
          component: Report_account_receivable,
          meta: {
            crumbs: '/รายงาน /รายงานลูกหนี้',
          },
        },
        {
          path: '/report/inventory',
          name: 'Report_inventory',
          component: Report_inventory,
          meta: {
            crumbs: '/รายงาน /รายงานลูกหนี้',
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        Auth.logout();

        Snackbar.open("You're logged out.");

        next('/login');
      },
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js